import React, { useEffect, useState } from 'react'
import CarouselComponent from './CarouselComponent'
import HomeBody from './HomeBody'
import NewsLine from './NewsLine';


const Home = () => {

  return (
  <>
    <NewsLine/>
    <CarouselComponent/>
    <HomeBody/>
  </>
  )
}

export default Home
